import {DoraProperty} from '../../../Decorators/Decorator';

export class Id {
    @DoraProperty
    public key = '';
}
